export default __webpack_public_path__ + "static/media/line_fourLimbs.850ad021.png";